import React from "react";
import _ from "lodash";

const useModelWithAutoCalculatedField = (calculationHelper, defaults) => {
  const [model, setModel] = React.useState(() => ({
    ...calculationHelper.getInitialModel(defaults),
    is_auto_calculation: false // defaults.is_auto_calculation, FIXME: DISABLED FOR NOW as part of BCA-10671
  }));

  // FIXME: DISABLED FOR NOW as part of BCA-10671
  // const calculatedValue = React.useMemo(() => {
  //   return calculationHelper.isAutoCalcAvailable(model) ? calculationHelper.calculateFieldValue(model) : null
  // }, [...calculationHelper.getCalculationDeps(model)]);

  const currentValue =
    // model.is_auto_calculation ? calculatedValue : FIXME: DISABLED FOR NOW as part of BCA-10671
      model[calculationHelper.fieldName];

  const handleModelChange = React.useCallback((field) => (value) => {
    setModel((prev) => {
      const nextFields = { ...prev, [field]: value };

      // FIXME: DISABLED FOR NOW as part of BCA-10671
      // // perform the "Auto-Enable/Disable" check if field from calc deps changes
      // if (calculationHelper.depsFields.includes(field)) {
      //   const isAutoCalcAvailable = calculationHelper.isAutoCalcAvailable(nextFields);
      //   // AUTO-ON: If it just became available and there's no "manual" values
      //   if (isAutoCalcAvailable && _.isNil(nextFields.is_auto_calculation) && !nextFields[calculationHelper.fieldName]) {
      //     nextFields.is_auto_calculation = true;
      //   } else if (!isAutoCalcAvailable && nextFields.is_auto_calculation) { // AUTO-OFF: If it just became not ready
      //     nextFields.is_auto_calculation = false;
      //   }
      // }

      return nextFields;
    })
  }, [calculationHelper]);

  // FIXME: DISABLED FOR NOW as part of BCA-10671
  return [model, handleModelChange, currentValue, false] //&& calculationHelper.isAutoCalcAvailable(model)];
};

export default useModelWithAutoCalculatedField;